import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'
import { messagingBannerHeight } from 'components/set/MessagingBanner/styles'
import { navBarHeight } from 'styling/theme'
import { playerMobileHeight } from 'styling/theme'

const iwTopMargin = 20

export default makeStyles((theme: Theme) => ({
    hasBanner: {},
    contentWrapper: {},
    liveContent: {},
    interactionWidget: {},
    hide: {
        display: 'none',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.colors.black,
        '&::before': {
            content: '""',
            position: 'absolute',
            height: '100vh',
            width: '100%',
            zIndex: 1,
            backgroundImage: 'linear-gradient(to bottom, rgba(31, 37, 51, 0) 6%, #0e1117 calc(100vw / (5/2)))',
        },
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        zIndex: 2,
        marginTop: 230,
        '@media (min-width: 1024px)': {
            margin: 'auto',
            maxWidth: 1760,
            width: '100%',
        },
        '@supports (margin: min(1px, 1px))': {
            marginTop: 'min(calc(72% / (5/2)), 414px)',
        },
    },
    notTv: {
        '& $contentWrapper': {
            '@media (min-width: 768px)': {
                display: 'flex',
            },
        },
        '& $liveContent': {
            position: 'relative',
            '@media (min-width: 768px)': {
                padding: 16,
                paddingTop: 0,
                maxWidth: `calc(100% - 320px)`,
                flexBasis: `calc(100% - 320px)`,
                marginTop: 20,
            },
            '@media (min-width: 1024px)': {
                maxWidth: `calc(100% - 400px)`,
                flexBasis: `calc(100% - 400px)`,
            },
        },
        '& $interactionWidget': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            height: `calc(100vh - ${playerMobileHeight}vw)`,
            width: '100%',
            position: 'absolute',
            right: 0,
            zIndex: 2,
            '@media (min-width: 768px)': {
                marginRight: 16,
                width: 320,
                marginTop: iwTopMargin,
                height: `calc(100vh - ${navBarHeight}px)`,
                overflowX: 'auto',
            },
            '@media (min-width: 1024px)': {
                width: 400,
            },
            '@supports (position: sticky)': {
                position: 'sticky',
                top: navBarHeight,
                '@media (min-width: 768px)': {
                    '&$hasBanner': {
                        height: `calc(100vh - ${messagingBannerHeight}px - ${iwTopMargin}px - ${navBarHeight}px)`,
                        top: messagingBannerHeight + navBarHeight + iwTopMargin,
                    },
                },
            },
        },
    },

    smartTv: {
        '& $contentWrapper': {
            display: 'flex',
            flexDirection: 'column',
        },
        '& $liveContent': {
            padding: 16,
            paddingTop: 0,
            position: 'relative',
            '&$hasBanner': {
                marginTop: 20,
            },
        },
        '& $interactionWidget': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            zIndex: 2,
            width: 'calc(100% - 32px)',
            marginLeft: 16,
            marginRight: 16,
            marginBottom: 20,
            height: 600,
            '& > div': {
                position: 'relative !important',
            },
        },
    },
}))
